import { render, staticRenderFns } from "./TemplateText.vue?vue&type=template&id=2a8a7e1b&scoped=true&"
import script from "./TemplateText.vue?vue&type=script&lang=js&"
export * from "./TemplateText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8a7e1b",
  null
  
)

export default component.exports